import productReducer from './reducers';

export default productReducer;
